import React from "react";
import yellowIndicator from "@src/assets/svg/yellow-indicator-icon.svg";
import { OTAInstallActionButton } from "@src/components/atoms/ota-install-action-button/ota-install-action-button";
import styles from "./ota-backup-process-review-request-and-approve.module.scss";
import { useOtaBackupProcessReviewRequestAndApprove } from "./use-ota-backup-process-review-request-and-approve";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";

interface OTABackupProcessReviewRequestAndApproveProps {
  activeInstallationData?: ActiveInstallationProcessPayload | null;
}

const cssClassName = "ota-backup-process-review-request-and-approve";

export default function OTABackupProcessReviewRequestAndApprove({
  activeInstallationData,
}: OTABackupProcessReviewRequestAndApproveProps) {
  const { texts, descriptionText, showContent, handleReviewRequestAndApprove } =
    useOtaBackupProcessReviewRequestAndApprove({ activeInstallationData });

  if (!showContent) return null;

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__content`]}>
        <img
          src={yellowIndicator}
          alt=""
          className={styles[`${cssClassName}__indicator`]}
        />
        <div className={styles[`${cssClassName}__text`]}>
          <span className={styles[`${cssClassName}__title`]}>
            {texts.title}
          </span>
          <span className={styles[`${cssClassName}__description`]}>
            {descriptionText}
          </span>
        </div>
      </div>

      <OTAInstallActionButton
        text={texts.reviewAndApproveButtonText}
        variant="primary"
        fun={handleReviewRequestAndApprove}
      />
    </div>
  );
}
